"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATEPICKER_MASK = exports.DATEPICKER_FORMAT = void 0;
exports.DATEPICKER_FORMAT = 'dd/MM/yyyy';
exports.DATEPICKER_MASK = '99/99/9999';
//# sourceMappingURL=constants.js.map